import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, ConfigModule, DeferLoadingStrategy } from '@spartacus/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { MyAccountMobileModule } from './my-account-mobile/my-account-mobile.module';
import { MyAccountComponent } from './my-account.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    NgbDropdownModule,
    MatListModule,
    SharedModule,
    MyAccountMobileModule,
    MatDialogModule,
    ConfigModule.withConfig({
      cmsComponents: {
        B2BAccountComponent: {
          component: MyAccountComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
    MyAccountComponent,
  ],
  exports: [MyAccountComponent],
  providers: [MyAccountComponent],
})
export class MyAccountModule {}
